<div class="sidebar-div" *ngIf='sidebar'>
    <div id="overlay">
        <nav class="sidebar" id="mySidebar" (mouseover)="collapseSidebar()" (mouseout)="collapseSidebar()">
            <div
                class="left-0 d-block fixed top-0 bottom-0 overflow-y-auto flex-row flex-nowrap overflow-hidden flex-column align-items-stretch px-0 d-flex flex-wrap align-items-center justify-content-between">
                <a [routerLink]="['/home']"
                    class="d-block text-s d-inline-block whitespace-nowrap text-uppercase fw-bold pt-4 ps-4">
                    <span class="q-logo1">
                        <img [src]="'SIDEBAR.Q-LOGO1' | translate" alt="" /></span>
                    <span class="q-logo2">
                        <img [src]="'SIDEBAR.Q-LOGO2' | translate" alt="" /></span>
                </a>

                <div
                    class="pt-30 ps-3 flex flex-column align-items-stretch relative shadow absolute top-0 left-0 right-0 z-40 overflow-y-auto overflow-x-hidden h-auto align-items-center flex-1 rounded">
                    <ul class="flex-column min-w-100 d-flex list-unstyled">
                        <li class="align-items-center q-sidebar-text" routerLink="/home/main-content"
                            [routerLinkActive]="['active']">
                            <strong></strong>
                            <strong></strong>
                            <a>
                                <img [src]="'SIDEBAR.DBOARD2' | translate" class="me-2 inactiveIcon" alt="Dashboard" />
                                <img [src]="'SIDEBAR.DBOARD1' | translate" class="me-2 activeIcon" alt="Dashboard" />
                                <span> {{ "SIDEBAR.HOME" | translate }}</span>
                            </a>
                        </li>

                        <li class="align-items-center q-sidebar-text" routerLink="/home/manage-user"
                            [routerLinkActive]="['active']">
                            <strong></strong>
                            <strong></strong>
                            <a>
                                <img [src]="'SIDEBAR.MANAGEUSER2' | translate" class="me-2 inactiveIcon"
                                    alt="manage-users" />
                                <img [src]="'SIDEBAR.MANAGEUSER1' | translate" class="me-2 activeIcon"
                                    alt="manage-users" />
                                <span>
                                    {{ "SIDEBAR.MANAGEUSERS" | translate }}
                                </span>
                            </a>
                        </li>

                        <li class="align-items-center q-sidebar-text" routerLink="/home/manage-device"
                            [routerLinkActive]="['active']">
                            <strong></strong>
                            <strong></strong>
                            <a>
                                <img [src]="'SIDEBAR.MYDEVICE2' | translate" class="me-2 inactiveIcon"
                                    alt="manage-devices" />
                                <img [src]="'SIDEBAR.MYDEVICE1' | translate" class="me-2 activeIcon"
                                    alt="manage-devices" />
                                <span>
                                    {{ "SIDEBAR.MANAGEDEVICES" | translate }}
                                </span>
                            </a>
                        </li>
                        <li class="align-items-center q-sidebar-text" routerLink="/home/score-management"
                            [routerLinkActive]="['active']">
                            <strong></strong>
                            <strong></strong>
                            <a>
                                <img [src]="'SIDEBAR.SCORE2' | translate" class="me-2 inactiveIcon" alt="history" />
                                <img [src]="'SIDEBAR.ACTIVESCORE' | translate" class="me-2 activeIcon" alt="history" />
                                <span>
                                    {{ "SIDEBAR.SCOREMANAGEMENT" | translate }}
                                </span>
                            </a>
                        </li>
                        <li class="align-items-center q-sidebar-text" routerLink="/home/reports"
                            [routerLinkActive]="['active']">
                            <strong></strong>
                            <strong></strong>
                            <a>
                                <img [src]="'SIDEBAR.REPORTS2' | translate" class="me-2 inactiveIcon" alt="reports" />
                                <img [src]="'SIDEBAR.REPORTS1' | translate" class="me-2 activeIcon" alt="reports" />
                                <span>
                                    {{ "SIDEBAR.INSIGHTS" | translate }}
                                </span>
                            </a>
                        </li>
                        <li class="align-items-center q-sidebar-text" routerLink="/home/license-summary"
                            [routerLinkActive]="['active']">
                            <strong></strong>
                            <strong></strong>
                            <a>
                                <img [src]="'SIDEBAR.LICENSESUMMARY2' | translate" class="me-2 inactiveIcon"
                                    alt="license-summary" />
                                <img [src]="'SIDEBAR.LICENSESUMMARY1' | translate" class="me-2 activeIcon"
                                    alt="license-summary" />
                                <span>
                                    {{ "SIDEBAR.LICENSESUMMARY" | translate }}
                                </span>
                            </a>
                        </li>

                        <!-- <li class="align-items-center q-sidebar-text" routerLink="/home/settings"
                            [routerLinkActive]="['active']">
                            <strong></strong>
                            <strong></strong>
                            <a>
                                <img [src]="'SIDEBAR.SETTINGS2' | translate" class="me-2 inactiveIcon" alt="settings" />
                                <img [src]="'SIDEBAR.SETTINGS1' | translate" class="me-2 activeIcon" alt="settings" />
                                <span>
                                    {{ "SIDEBAR.SETTINGS" | translate }}
                                </span>
                            </a>
                        </li> -->

                        <li class="align-items-center q-sidebar-text" routerLink="/home/activity-history"
                            [routerLinkActive]="['active']">
                            <strong></strong>
                            <strong></strong>
                            <a>
                                <img [src]="'SIDEBAR.HISTORY2' | translate" class="me-2 inactiveIcon" alt="history" />
                                <img [src]="'SIDEBAR.HISTORY1' | translate" class="me-2 activeIcon" alt="history" />
                                <span>
                                    {{ "SIDEBAR.ACTIVITYHISTORY" | translate }}
                                </span>
                            </a>
                        </li>

                        <li class="align-items-center q-sidebar-text" routerLink="/home/faq-support"
                            [routerLinkActive]="['active']">
                            <strong></strong>
                            <strong></strong>
                            <a>
                                <img [src]="'SIDEBAR.HELP2' | translate" class="me-2 inactiveIcon" alt="Help" />
                                <img [src]="'SIDEBAR.HELP1' | translate" class="me-2 activeIcon" alt="Help" />
                                <span>
                                    {{ "SIDEBAR.HELP" | translate }}
                                </span>
                            </a>
                        </li>

                    </ul>
                </div>
            </div>
        </nav>
    </div>
</div>